"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDocumentListState = exports.DocumentListContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const getDocuments_1 = require("../api/getDocuments");
const DocumentListContext = (0, react_1.createContext)({});
const DocumentListContextProvider = ({ children }) => {
    const documentListResponse = (0, getDocuments_1.useDocumentList)();
    const getDocumentDetails = (code) => {
        return documentListResponse?.data?.find((doc) => doc.code === code);
    };
    const state = (0, react_1.useMemo)(() => ({
        documentList: documentListResponse?.data,
        getDocumentDetails,
    }), [documentListResponse]);
    return (0, jsx_runtime_1.jsx)(DocumentListContext.Provider, { value: state, children: children });
};
exports.DocumentListContextProvider = DocumentListContextProvider;
const useDocumentListState = () => {
    const context = (0, react_1.useContext)(DocumentListContext);
    if (!context) {
        throw new Error('Must use useDocumentListState in DocumentListContext');
    }
    return context;
};
exports.useDocumentListState = useDocumentListState;
//# sourceMappingURL=DocumentListContext.js.map